<div style="margin-top: 30px;" class="container shippn-homepage-container">
  <div class="row">
    <div class="col-md-12">
      <h1 *ngIf="countryDetails" class="header-underline-black-left"
        style="font-size: 28px;font-weight: bold;margin-bottom: 27px;color: black;">Worldwide Shipping: Our Hosts in
        {{countryDetails.data.name}}</h1>
    </div>
  </div>

  <div style="margin-top: 25px;" class="row">
    <div class="col-lg-3 d-none d-sm-none d-xs-none d-md-none d-lg-block">
      <div
        style="background-color: #222222;border-radius: 10px;box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);padding: 15px; margin-bottom: 20px;">
        <h4 style="font-size: 18px;font-weight: 500;margin-bottom: 10px;color: white;">Change Country</h4>
        <div style="margin-top: 5px;position: relative; border-radius: 5px; background-color: #fff;"
          class="select--wrapper">
          <i class="fas fa-chevron-down"
            style="position: absolute; right: 10px; top: 9px;float: right; color: #222222; border-radius: 32%; padding: 7px; font-size: 12px;"
            aria-hidden="true"></i>
          <select 
            (change)="getHostsFrom(countryFrom)" 
            [(ngModel)]="countryFrom" 
            style="-webkit-appearance: none;-moz-appearance: none;appearance: none; font-family: 'Roboto', sans-serif; width: 100%; border-radius: 5px; padding: 9px 14px; font-size: 16px; height: 42px;">
            <option value="" disabled>Please select a country</option>
            <option *ngFor="let countriesWithHost of hostCountries" [value]="countriesWithHost.code.toUpperCase()">
              <span *ngIf="countriesWithHost.code !== 'TR' && countriesWithHost.name !== 'Turkey'">{{ countriesWithHost.name }}</span>
              <span *ngIf="countriesWithHost.code === 'TR' || countriesWithHost.name === 'Turkey'" translate="no">Türkiye</span>
            </option>
          </select>
        </div>
      </div>

      <div
        style="background-color: #222222;border-radius: 10px;box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);padding: 15px;min-height: 783px;">
        <h4 style="font-size: 18px;font-weight: 500;margin-bottom: 20px;color: white;">Filters</h4>

        <div style="background-color:#ffffff;border-radius: 10px;padding: 13px;">
          <h4 style="font-size: 16px;font-weight: normal;margin-bottom: 10px;color: #222222;">Additional Services</h4>
          <div class="form-check">
            <input (change)="filterWithAPI(hasConsolidation,hasItemPhotos,hasRepacking,hasStorage)"
              [(ngModel)]="hasConsolidation" class="form-check-input" type="checkbox" value="" id="consalidation">
            <label style="font-size: 16px;font-weight: 300;" class="form-check-label" for="consalidation">
              Consolidation
            </label>
          </div>
          <div class="form-check">
            <input (change)="filterWithAPI(hasConsolidation,hasItemPhotos,hasRepacking,hasStorage)"
              [(ngModel)]="hasItemPhotos" class="form-check-input" type="checkbox" value="" id="itemPhotos">
            <label style="font-size: 16px;font-weight: 300;" class="form-check-label" for="itemPhotos">
              Item Photos
            </label>
          </div>
          <div class="form-check">
            <input (change)="filterWithAPI(hasConsolidation,hasItemPhotos,hasRepacking,hasStorage)"
              [(ngModel)]="hasRepacking" class="form-check-input" type="checkbox" value="" id="repacking">
            <label style="font-size: 16px;font-weight: 300;" class="form-check-label" for="repacking">
              Repacking
            </label>
          </div>
          <div class="form-check">
            <input (change)="filterWithAPI(hasConsolidation,hasItemPhotos,hasRepacking,hasStorage)"
              [(ngModel)]="hasStorage" class="form-check-input" type="checkbox" value="" id="storage">
            <label style="font-size: 16px;font-weight: 300;" class="form-check-label" for="storage">
              Storage
            </label>
          </div>
        </div>

        <div style="background-color:#ffffff;border-radius: 10px;padding: 13px;margin-top: 15px;">
          <h4 style="font-size: 16px;font-weight: normal;margin-bottom: 10px;color: #222222;">Host Languages</h4>

          <div *ngFor="let language of languageArray" class="form-check">
            <input (change)="filterLanguages()" class="form-check-input" type="checkbox" value="" id="language">
            <label style="font-size: 16px;font-weight: 300;" class="form-check-label" for="language">
              {{language}}
            </label>
          </div>
        </div>

        <div style="padding: 5px;margin-top: 10px;">
          <div>
            <h4 style="font-size: 16px;font-weight: normal;margin-bottom: 10px;color: white;float: left;">Host Rate:
            </h4>
            <h4 style="font-size: 16px;font-weight: normal;margin-bottom: 10px;color: white;float: right;">
              {{hostRate}}/5</h4>
          </div>


          <input [(ngModel)]="hostRate" style="width: 100%;" type="range" class="form-range" min="0" step="0.5" max="5"
            id="customRange2">
        </div>
      </div>
    </div>

    <div class="col-lg-3 d-block d-sm-block d-xs-block d-md-block d-lg-none">
      <div
        style="margin-top: 5px; border: 0; border-radius: 10px; margin-bottom: 20px;position: relative; background-color: #222222;"
        class="select--wrapper">
        <i class="fas fa-chevron-down"
          style="position: absolute; right: 13px; top: 9px;float: right; color: white; border-radius: 32%; padding: 7px; font-size: 12px;"
          aria-hidden="true"></i>
        <select (change)="getHostsFrom(countryFrom)" 
        [(ngModel)]="countryFrom" 
          style="-webkit-appearance: none;-moz-appearance: none;appearance: none;font-weight: 500; font-size: 18px; width: 100%;  border-color: #222222; border-radius: 10px; appearance: none;padding: 7px 13px; color: #fff; height: 42px;font-family: 'Roboto',sans-serif;">
          <option value="" disabled>Please select a country</option>
            <option *ngFor="let countriesWithHost of hostCountries" [value]="countriesWithHost.code.toUpperCase()">
              <span *ngIf="countriesWithHost.code !== 'TR' && countriesWithHost.name !== 'Turkey'">{{ countriesWithHost.name }}</span>
              <span *ngIf="countriesWithHost.code === 'TR' || countriesWithHost.name === 'Turkey'" translate="no">Türkiye</span>
            </option>
        </select>
      </div>


      <div style="margin-bottom: 25px;" class="accordion" id="accordionExample">
        <div style="background-color: #222222;border-radius: 10px;box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);"
          class="card">
          <div style="padding: 0px;" class="card-header" id="headingOne">

            <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
              data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
              <h4 style="font-size: 18px;font-weight: 500;color: white;float: left;margin-bottom: 0px;">Filters</h4>
              <i style="float: right;color: white;border-radius: 32%;padding: 7px;font-size: 12px;"
                class="fas fa-chevron-down"></i>
            </button>
          </div>

          <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
            <div class="card-body">
              <div style="background-color:#ffffff;border-radius: 10px;padding: 13px;">
                <h4 style="font-size: 16px;font-weight: normal;margin-bottom: 10px;color: #222222;">Additional Services
                </h4>
                <div class="form-check">
                  <input (change)="filterWithAPI(hasConsolidation,hasItemPhotos,hasRepacking,hasStorage)"
                    [(ngModel)]="hasConsolidation" class="form-check-input" type="checkbox" value="" id="consalidation">
                  <label style="font-size: 16px;font-weight: 300;" class="form-check-label" for="consalidation">
                    Consolidation
                  </label>
                </div>
                <div class="form-check">
                  <input (change)="filterWithAPI(hasConsolidation,hasItemPhotos,hasRepacking,hasStorage)"
                    [(ngModel)]="hasItemPhotos" class="form-check-input" type="checkbox" value="" id="itemPhotos">
                  <label style="font-size: 16px;font-weight: 300;" class="form-check-label" for="itemPhotos">
                    Item Photos
                  </label>
                </div>
                <div class="form-check">
                  <input (change)="filterWithAPI(hasConsolidation,hasItemPhotos,hasRepacking,hasStorage)"
                    [(ngModel)]="hasRepacking" class="form-check-input" type="checkbox" value="" id="repacking">
                  <label style="font-size: 16px;font-weight: 300;" class="form-check-label" for="repacking">
                    Repacking
                  </label>
                </div>
                <div class="form-check">
                  <input (change)="filterWithAPI(hasConsolidation,hasItemPhotos,hasRepacking,hasStorage)"
                    [(ngModel)]="hasStorage" class="form-check-input" type="checkbox" value="" id="storage">
                  <label style="font-size: 16px;font-weight: 300;" class="form-check-label" for="storage">
                    Storage
                  </label>
                </div>
              </div>

              <div style="background-color:#ffffff;border-radius: 10px;padding: 13px;margin-top: 15px;">
                <h4 style="font-size: 16px;font-weight: normal;margin-bottom: 10px;color: #222222;">Host Languages</h4>

                <div *ngFor="let language of languageArray" class="form-check">
                  <input (change)="filterLanguages()" class="form-check-input" type="checkbox" value="" id="language">
                  <label style="font-size: 16px;font-weight: 300;" class="form-check-label" for="language">
                    {{language}}
                  </label>
                </div>
              </div>

              <div style="padding: 5px;margin-top: 10px;">
                <div>
                  <h4 style="font-size: 16px;font-weight: normal;margin-bottom: 10px;color: white;float: left;">Host
                    Rate:</h4>
                  <h4 style="font-size: 16px;font-weight: normal;margin-bottom: 10px;color: white;float: right;">
                    {{hostRate}}/5</h4>
                </div>


                <input [(ngModel)]="hostRate" style="width: 100%;" type="range" class="form-range" min="0" step="0.5"
                  max="5" id="customRange2">
              </div>
            </div>
          </div>
        </div>

      </div>


    </div>
    <div class="col-lg-9">

      <div style="margin-bottom: 15px;">
        <app-shippnpilot-widget [shippnpilotWidgetType]="'both'"></app-shippnpilot-widget>
      </div>



      <h4 *ngIf="hostList" style="font-size: 18px;font-weight: bold;margin-bottom: 20px;color: black;">Please select one
        of our great hosts below</h4>

      <div class="shippn-hosts-list-shippn-guaranty">
        <div class="shippn-hosts-list-shippn-guaranty-icon">
          <img src="assets/img/hosts-list/shippn_guaranty.png" alt="Shippn Guaranty">
        </div>
        <div class="shippn-hosts-list-shippn-guaranty-content">
          <p>
            We've got you covered! Shop with confidence knowing Shippn's guarantee fully covers your packages.
          </p>
        </div>

      </div>


      <div class="row" *ngIf="!hostsCountriesIncludeParamCountry || hostListLengthIsZero">
        <div class="col-12">
          <h3 style="font-size: 18px;font-weight: bold;margin-bottom: 20px;color: black;"> You can shop from locations
            below:</h3>
          <div class="bfm-countries-wrapper">
            <div class="bfm-country" *ngFor="let country of hostCountries | slice:0:5"
              [routerLink]="['/', lang,'shop-from', country?.code]">
              <div class="bfm-country-flag">
                <img async src="https://www.shippn.com/assets/img/flags/{{country.country_flag}}"
                  alt="BFM Country Flag">
              </div>
              <div class="bfm-country-name">
                <span *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                <span *ngIf="country.code == 'TR' || country.name == 'Turkey'" translate="no">Türkiye</span>
              </div>
            </div>
            <div class="bfm-country" *ngFor="let country of hostCountries | slice:5:10"
              [routerLink]="['/', lang,'shop-from', country?.code]">
              <div class="bfm-country-flag">
                <img async src="https://www.shippn.com/assets/img/flags/{{country.country_flag}}"
                  alt="BFM Country Flag">
              </div>
              <div class="bfm-country-name">
                <span *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                <span *ngIf="country.code == 'TR' || country.name == 'Turkey'" translate="no">Türkiye</span>
              </div>
            </div>
            <div class="bfm-country" *ngFor="let country of hostCountries | slice:10:15"
              [routerLink]="['/', lang,'shop-from', country?.code]">
              <div class="bfm-country-flag">
                <img async src="https://www.shippn.com/assets/img/flags/{{country.country_flag}}" alt="BFM Country Flag"
                  *ngIf="country.code != 'TP'">
              </div>
              <div class="bfm-country-name">
                <span *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                <span *ngIf="country.code == 'TR' || country.name == 'Turkey'" translate="no">Türkiye</span>
              </div>
            </div>
            <div class="bfm-country" *ngFor="let country of hostCountries | slice:15:20"
              [routerLink]="['/', lang,'shop-from', country?.code]">
              <div class="bfm-country-flag">
                <img async src="https://www.shippn.com/assets/img/flags/{{country.country_flag}}" alt="BFM Country Flag"
                  *ngIf="country.code != 'TP'">
              </div>
              <div class="bfm-country-name">
                <span *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                <span *ngIf="country.code == 'TR' || country.name == 'Turkey'" translate="no">Türkiye</span>
              </div>
            </div>
            <div class="bfm-country" *ngFor="let country of hostCountries | slice:20:25"
              [routerLink]="['/', lang,'shop-from', country?.code]">
              <div class="bfm-country-flag">
                <img async src="https://www.shippn.com/assets/img/flags/{{country.country_flag}}" alt="BFM Country Flag"
                  *ngIf="country.code != 'TP'">
              </div>
              <div class="bfm-country-name">
                <span *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                <span *ngIf="country.code == 'TR' || country.name == 'Turkey'" translate="no">Türkiye</span>
              </div>
            </div>
            <div class="bfm-country" *ngFor="let country of hostCountries | slice:25:30"
              [routerLink]="['/', lang,'shop-from', country?.code]">
              <div class="bfm-country-flag">
                <img async src="https://www.shippn.com/assets/img/flags/{{country.country_flag}}" alt="BFM Country Flag"
                  *ngIf="country.code != 'TP'">
              </div>
              <div class="bfm-country-name">
                <span *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                <span *ngIf="country.code == 'TR' || country.name == 'Turkey'" translate="no">Türkiye</span>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="row hosts-wrapper" *ngIf="hostsCountriesIncludeParamCountry">

        <div *ngFor="let host of hostList | hostRatePipe:hostRate:hasConsolidation; let index = index"
          style="margin-top: 70px;" class="col-12 host-card">

          <div *ngIf="host.is_list && !host.is_new_host"
            style="border-radius: 10px;box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);min-height: 301px;"
            class="host-card-h">
            <div
              style="height: 50px;background-color: #222222;border-top-left-radius: 7px;border-top-right-radius: 7px;">
              <div style="text-align: center;position: relative;top: -45px;">
                <img style="width: 95px;height: 95px;object-fit: cover;border-radius: 50%;border: 2px solid black;"
                  class="img-responsive img-circle" src="{{host.profile_image_url}}" alt="Shippn Host Profile picture">
              </div>
            </div>
            <div style="padding: 10px 15px;" class="host-card-body-fixer">
              <div
                style="text-align: center; border-bottom: 1px solid #707070; padding-bottom: 10px; margin-bottom: 10px;">
                <h4 style="font-size: 16px;font-weight: 900;color: black;margin-bottom: 2px;" translate="no">
                  {{host.name}}</h4>
                <h4 style="font-size: 13px;font-weight: 300;color: black;margin: 0;">{{host.city_name}}</h4>
                <div style="text-align: center;display: inline-flex; align-items: flex-end;" class="rate-star-div">
                  <span style="font-size: 14px; font-weight: normal;margin-right: 5px;"></span>
                  <div class="star"
                    style="display: flex; flex-direction: row; align-items: center; justify-content:center;">
                    <img *ngIf="host.average_rate > 0" style="height: 16px;"
                      src="../../assets/img/shippn-rated-star-icon.png" alt="rated star icon">
                    <span style="font-size: 14px; font-weight: 500;margin-top: 2px;margin-left: 2px; color:#707070"
                      *ngIf="host.average_rate > 0">{{host.average_rate}}</span>
                    <span *ngIf="host.average_rate > 0" style="
                      font-weight: bold;
                      color: #707070;
                      margin-top: 3px;
                      padding-left: 2px;
                      padding-right: 2px;
                  ">&#8226;</span>
                    <a *ngIf="host?.reviewsCount > 0" [routerLink]="['/', lang, 'getaddress-host', host.id]"
                      style="font-size: 14px; font-weight: 500;margin-top: 2px;margin-left: 2px; color:#707070; text-decoration: underline;">{{host?.reviewsCount}}
                      reviews</a>
                  </div>

                </div>
              </div>
              <!-- <hr style="border-bottom: 1px solid #707070;margin-top: 10px;"> -->

              <div class="host-list-order-properties-padding"
                style="text-align: left;min-height: 73px;display:inline-grid;align-items:baseline;">
                <div
                *ngIf="
                host.id == '614df8ff51d75f19b6b66d32' ||
                host.id == '62e2ba1751d75f69d96a3acf' ||
                host.id == '60eb02f151d75f65b380ac4a' ||
                host.id == '65494ccc51d75f059e5fa8e0' ||
                host.id == '62309b0951d75f0fc6b2480e'"

                  style="text-align: center;display: inline-flex; align-items: center;">
                  <img style="width: 17px;" src="../../assets/img/tax-free.png" alt="tax free badge">
                  <span style="font-size: 12px; font-weight: normal;margin-left: 5px;color: #fc7137;">Tax Free</span>
                </div>

                <div style="text-align: center;display: inline-flex; align-items: center;">
                  <img style="width: 17px;" src="../../assets/img/shippn-handled-packages-icon.png"
                    alt="Shippn Handled Packages icon">
                  <span style="font-size: 12px; font-weight: bold;margin-left: 5px;">{{host.sent_package_count}}</span>
                  <span style="font-size: 12px; font-weight: normal;margin-left: 5px;">Handled Packages</span>
                </div>
                <div *ngIf="host.fast_shipment" style="text-align: center;display: inline-flex; align-items: center;">
                  <img style="width: 17px;" src="../../assets/img/shippn-fast-shipping-icon.png"
                    alt="Shippn Fast Shippng Icon">
                  <span style="font-size: 12px; font-weight: normal;margin-left: 5px;">Fast Shipping</span>
                </div>

                <div style="text-align: center;display: inline-flex; align-items: center;">
                  <img style="width: 17px;" src="../../assets/img/shippn-additional-services-icon.png"
                    alt="Shippn additional services icon">
                  <span style="font-size: 12px; font-weight: normal;margin-left: 5px;">Provides Additional
                    Services</span>
                </div>
              </div>
              <div style="text-align: center;"
                style="display: flex; gap: 15px; align-items: center; justify-content: center; flex-direction:column-reverse;">
                <button [routerLink]="[ '/', lang,'host', 'getaddress-details', host.id]"
                  [queryParams]="{product_url: paramProductUrl}" [disabled]="host.is_list == 0 && elf_auth == 0"
                  style="font-size: 11px;font-weight: bold;background-color: #fc7137 !important;"
                  class="btn shippn-from-to-area-go-btn" [attr.data-cy]="'host'+index">
                  <span *ngIf="host.is_list != 0 || elf_auth != 0">GET THIS ADDRESS</span>
                  <span *ngIf="host.is_list == 0 && elf_auth == 0">CURRENTLY UNAVAILABLE</span>
                </button>
              </div>
            </div>
          </div>

          <div *ngIf="host.is_list && host.is_new_host"
            style="border-radius: 10px;box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);min-height: 301px;"
            class="host-card-h">
            <div
              style="height: 50px;background-color: #fc7137;border-top-left-radius: 7px;border-top-right-radius: 7px;">
              <div style="text-align: center;position: relative;top: -45px;">
                <img style="width: 95px;height: 95px;object-fit: cover;border-radius: 50%;border: 2px solid #fc7137;"
                  class="img-responsive img-circle" src="{{host.profile_image_url}}"
                  alt="Shippn Host profile picture, avatar">
              </div>
            </div>
            <div style="padding: 10px 15px;" class="host-card-body-fixer">
              <div style="text-align: center;">
                <h4 style="font-size: 16px;font-weight: 900;color: black;margin-bottom: 2px;" translate="no">
                  {{host.name}}</h4>
                <h4 style="font-size: 13px;font-weight: 300;color: black;margin: 0;">{{host.city_name}}</h4>
                <img style="width: 85px;margin-top: 5px;" src="../../assets/img/shippn-rated-big-star-icon.png"
                  alt="Big Rated Star Icon">
                <h4 style="font-size: 20px;font-weight: 900;color: black;margin-top: 7px;margin-bottom: 5px;">NEW HOST
                </h4>
                <h4 style="font-size: 13px;font-weight: 300;color: black;margin: 0;">Give A Chance</h4>
                <div style="text-align: center;display: inline-flex; align-items: flex-end;" class="rate-star-div"
                  *ngIf="host?.reviewsCount > 0">
                  <span style="font-size: 14px; font-weight: normal;margin-right: 5px;"></span>
                  <div class="star"
                    style="display: flex; flex-direction: row; align-items: center; justify-content:center;">
                    <img *ngIf="host.average_rate > 0" style="height: 16px;"
                      src="../../assets/img/shippn-rated-star-icon.png" alt="rated star icon">
                    <span *ngIf="host.average_rate > 0"
                      style="font-size: 14px; font-weight: 500;margin-top: 2px;margin-left: 2px; color:#707070">{{host.average_rate}}</span>
                    <span *ngIf="host.average_rate > 0" style="
                      font-weight: bold;
                      color: #707070;
                      margin-top: 3px;
                      padding-left: 2px;
                      padding-right: 2px;
                  ">&#8226;</span>
                    <a *ngIf="host?.reviewsCount > 0" [routerLink]="['/', lang, 'getaddress-host', host.id]"
                      style="font-size: 14px; font-weight: 500;margin-top: 2px;margin-left: 2px; color:#707070; text-decoration: underline;">{{host?.reviewsCount}}
                      reviews</a>
                  </div>

                </div>
              </div>

              <div style="text-align: center;">
                <button [routerLink]="[ '/', lang,'host', 'getaddress-details', host.id]"
                  [queryParams]="{product_url: paramProductUrl}" [disabled]="host.is_list == 0 && elf_auth == 0"
                  style="font-size: 11px;font-weight: bold;background-color: #fc7137 !important;padding: 11px 19px !important;width: 77%;margin-top: 15px;margin-bottom: 10px;border-radius: 10px;"
                  class="btn shippn-from-to-area-go-btn" [attr.data-cy]="'host'+index">
                  <span *ngIf="host.is_list != 0 || elf_auth != 0">GET THIS ADDRESS</span>
                  <span *ngIf="host.is_list == 0 && elf_auth == 0">CURRENTLY UNAVAILABLE</span>
                </button>
              </div>

            </div>
          </div>

          <div *ngIf="!host.is_list"
            style="border-radius: 10px;box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);min-height: 301px;"
            class="host-card-h">
            <div style="opacity: 0.4;">
              <div
                style="height: 50px;background-color: #222222;border-top-left-radius: 7px;border-top-right-radius: 7px;">
                <div style="text-align: center;position: relative;top: -45px;">
                  <img style="width: 95px;height: 95px;object-fit: cover;border-radius: 50%;border: 2px solid #0000009c"
                    class="img-responsive img-circle" src="{{host.profile_image_url}}"
                    alt="Shippn host profile picture, avatar">
                </div>
              </div>
              <div style="padding: 10px 15px;" class="host-card-body-fixer">
                <div
                  style="text-align: center; border-bottom: 1px solid #707070; padding-bottom: 10px; margin-bottom: 10px;">
                  <h4 style="font-size: 16px;font-weight: 900;color: black;margin-bottom: 2px;" translate="no">
                    {{host.name}}</h4>
                  <h4 style="font-size: 13px;font-weight: 300;color: black;margin: 0;">{{host.city_name}}</h4>
                  <div style="text-align: center;display: inline-flex; align-items: flex-end;" class="rate-star-div">
                    <div class="star"
                      style="display: flex; flex-direction: row; align-items: center; justify-content:center;">
                      <img *ngIf="host.average_rate > 0" style="height: 16px;"
                        src="../../assets/img/shippn-rated-star-icon.png" alt="rated star icon">
                      <span *ngIf="host.average_rate > 0"
                        style="font-size: 14px; font-weight: 500;margin-top: 2px;margin-left: 2px; color:#707070">{{host.average_rate}}</span>
                      <span *ngIf="host.average_rate > 0" style="
                      font-weight: bold;
                      color: #707070;
                      margin-top: 3px;
                      padding-left: 2px;
                      padding-right: 2px;
                  ">&#8226;</span>
                      <a *ngIf="host?.reviewsCount > 0"
                        style="font-size: 14px; font-weight: 500;margin-top: 2px;margin-left: 2px; color:#707070; text-decoration: underline;cursor: pointer;">{{host?.reviewsCount}}
                        reviews</a>
                    </div>
                  </div>
                </div>
                <!-- <hr style="border-bottom: 1px solid #707070;margin-top: 10px;"> -->
                <div class="host-list-order-properties-padding"
                  style="text-align: left;min-height: 73px;display:inline-grid;align-items:baseline;">
                  <div style="text-align: center;display: inline-flex; align-items: center;">
                    <img style="width: 17px;" src="../../assets/img/shippn-handled-packages-icon.png"
                      alt="Shippn Handled Packages Icon">
                    <span
                      style="font-size: 12px; font-weight: bold;margin-left: 5px;">{{host.sent_package_count}}</span>
                    <span style="font-size: 12px; font-weight: normal;margin-left: 5px;">Handled Packages</span>
                  </div>
                  <div *ngIf="host.fast_shipment" style="text-align: center;display: inline-flex; align-items: center;">
                    <img style="width: 17px;" src="../../assets/img/shippn-fast-shipping-icon.png"
                      alt="Shippn fast shipping icon">
                    <span style="font-size: 12px; font-weight: normal;margin-left: 5px;">Fast Shipping</span>
                  </div>
                  <div style="text-align: center;display: inline-flex; align-items: center;">
                    <img style="width: 17px;" src="../../assets/img/shippn-additional-services-icon.png"
                      alt="Shippn Additional services icon">
                    <span style="font-size: 12px; font-weight: normal;margin-left: 5px;">Provides Additional
                      Services</span>
                  </div>
                </div>
              </div>
            </div>

            <div style="text-align: center;">
              <button
                style="font-size: 11px;font-weight: bold;background-color: #222222 !important;padding: 11px 19px !important;width: 77%;margin-top: 21px;border-radius: 10px;"
                class="btn shippn-from-to-area-go-btn" [disabled]="!host.is_list">NOT AVAILABLE RIGHT NOW
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="shop-from-whats-next-wrapper" *ngIf="thereShopFromContent">
  <div class="container shippn-homepage-container">
    <h2 class="shop-from-whats-next-wrapper-title">{{currentShopFromContent.title}}</h2>
    <p style="font-size:14px;" [innerHTML]="currentShopFromContent.mainContent"></p>

    <div class="shop-from-whats-next-section-list">
      <div *ngFor="let section of currentShopFromContent.sections" class="shop-from-whats-next-section">
        <h3 class="shop-from-whats-next-section-heading">{{ section.heading }}</h3>
        <p [innerHTML]="section.content"></p>
      </div>
    </div>

    <div>
      <button *ngIf="!userID" class="btn shippn-from-to-area-go-btn" style="min-width: 200px"
        [routerLink]="['/', lang, currentShopFromContent.ctaRoute]">{{currentShopFromContent.ctaText}}</button>
    </div>



  </div>



</div>




<div
  style="background-image: url(../assets/img/country-background.webp); background-size: cover; background-repeat: no-repeat;margin-top: 50px;">
  <div class="shippn-homepage-container container">
    <div style="padding-bottom: 60px;" class="row">
      <div style="text-align: center;" class="col-md-12">
        <h2 class="header-underline-white"
          style="text-align: center;font-size: 28px;font-weight: bold;margin-bottom: 27px;color: white;margin-top: 55px;">
          OTHER COUNTRIES TO SHOP FROM</h2>
        <p style="color: white;margin-bottom: 27px;font-size: 15px;">Let our hosts forward your package to your home
          address.</p>
      </div>

      <div style="display: flex;align-items: center;padding-top: 20px;text-align:center;justify-content:center;"
        class="col-6 col-md-4">
        <h2 (click)="goLocation('uk')" class='top-countries-country-name'
          style="color: white;position: absolute;margin:0;cursor: pointer;z-index: 500">UK</h2>
        <a href="/{{lang}}/shop-from/uk">
          <img src="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-london-bg.jpg"
            alt="United Kingdom London Image" style="width:100%;object-fit: cover;filter: brightness(50%)">
        </a>

      </div>
      <div style="display: flex;align-items: center;padding-top: 20px;text-align:center;justify-content:center;"
        class="col-6 col-md-4">
        <h2 (click)="goLocation('us')" class='top-countries-country-name'
          style="color: white;position: absolute;margin:0;cursor: pointer;z-index: 500">U.S.A.</h2>
        <a href="/{{lang}}/shop-from/us">
          <img src="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-newyork-bg.jpg"
            alt="United States New York Image" style="width:100%;object-fit: cover;filter: brightness(50%)">
        </a>
      </div>
      <div style="display: flex;align-items: center;padding-top: 20px;text-align:center;justify-content:center;"
        class="col-6 col-md-4">
        <h2 (click)="goLocation('ca')" class='top-countries-country-name'
          style="color: white;position: absolute;margin:0;cursor: pointer;z-index: 500">CANADA</h2>
        <a href="/{{lang}}/shop-from/ca">
          <img src="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-toronto-bg.jpg" alt="Canada Toronto Image"
            style="width:100%;object-fit: cover;filter: brightness(50%)">
        </a>
      </div>
    </div>
  </div>
</div>